import type { AbilityBuilder, MongoQuery } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { Project } from '~/types/project.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineProjectAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  can('read', 'projects')
  can('read', 'projects-id-view')

  const roles = userRoles(user)

  if (roles.administrator || roles.client_lead) {
    can(['create', 'update', 'delete', 'restore'], 'project')
  }
  else {
    can('update', 'project', {
      'leads.id': user.id,
    } as MongoQuery<Project>)
  }
}
